import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'
import RefreshIndicator from 'material-ui/RefreshIndicator'
import CallListItem from './CallListItem'

const determineCallType = ({
  call_start: callStart,
  call_end: callEnd,
  direction,
  voicemail,
}) => {
  if (voicemail) {
    return 'missed voicemails'
  } else if (direction === 'inbound' && !callStart) {
    return 'missed'
  } else if (direction === 'inbound' && !!callStart) {
    return 'received'
  } else if (direction === 'outbound') {
    return 'outgoing'
  }
  if (!callEnd) {
    return direction === 'outbound' ? 'outgoing' : 'received'
  }
  return ''
}

const CallList = ({
  dateFormatted,
  callDataByDate,
  handleCallLogClick,
  callLogFilter,
  loading,
}) => {
  let callList
  if (!loading && dateFormatted in callDataByDate) {
    const callsSorted = callDataByDate[dateFormatted].sort((a, b) => (
      moment(b.ring_start).diff(moment(a.ring_start))
    ))
    const callsFiltered = callsSorted.filter(call => (
      callLogFilter === 'all' || determineCallType(call).includes(callLogFilter)
    ))

    if (callsFiltered.length === 0) {
      callList = <h3>There are no records on this day!</h3>
    } else {
      callList = callsFiltered.map(call => (
        <CallListItem
          key={call.id}
          callData={call}
          handleNameClick={() => handleCallLogClick(call.phone, call.name !== 'Unknown')}
        />
      ))
    }
  }

  return (
    <div className="callList">
      {loading &&
        <div className="loader">
          <RefreshIndicator
            size={50}
            top={0}
            left={0}
            status={'loading'}
            color="#1B78B3"
          />
        </div>
      }
      {callList}
    </div>
  )
}

CallList.propTypes = {
  dateFormatted: PropTypes.string.isRequired,
  callDataByDate: PropTypes.object.isRequired,
  handleCallLogClick: PropTypes.func.isRequired,
  callLogFilter: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
}

export default CallList



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/CallList.js